/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { FaHome, FaUserMd, FaSyringe } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
    return (
        <section className="py-16">
            <div className="mx-auto px-4">
                <div className="text-center max-w-3xl mx-auto mb-10">
                    <h2 className="text-2xl md:text-3xl font-black text-text-main dark:text-white mb-6">
                        Comprehensive healthcare tailored to you.
                    </h2>
                    <p className="text-text-secondary text-lg">
                        We provide a full range of nursing services to ensure your recovery is smooth and your long-term health is maintained.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    <div className="group bg-white dark:bg-slate-900 p-4 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                        <div className="size-14 rounded-2xl bg-primary/20 group-hover:bg-primary/25 dark:bg-blue-900/30 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                            <FaHome className="text-3xl" />
                        </div>
                        <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">Post-Op Recovery</h3>
                        <p className="text-text-secondary dark:text-slate-400 leading-relaxed">
                            Expert monitoring and wound care following surgical procedures to ensure a fast and safe recovery at home.
                        </p>
                        <hr className="my-6 border-slate-200 dark:border-slate-800" />
                        <Link
                            to={'/services'}
                            className="text-primary font-bold inline-flex items-center gap-2 group-hover:gap-3 transition-all"
                        >
                            Learn more <span className="text-sm">→</span>
                        </Link>
                    </div>
                    <div className="group bg-white dark:bg-slate-900 p-4 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                        <div className="size-14 rounded-2xl bg-primary/20 group-hover:bg-primary/25 dark:bg-blue-900/30 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                            <FaUserMd className="text-3xl" />
                        </div>
                        <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">Geriatric Care</h3>
                        <p className="text-text-secondary dark:text-slate-400 leading-relaxed">
                            Dedicated elderly care focusing on mobility, medication management, and overall well-being of your loved ones.
                        </p>
                        <hr className="my-6 border-slate-200 dark:border-slate-800" />
                        <Link
                            to={'/services'}
                            className="text-primary font-bold inline-flex items-center gap-2 group-hover:gap-3 transition-all"
                        >
                            Learn more <span className="text-sm">→</span>
                        </Link>
                    </div>
                    <div className="group bg-white dark:bg-slate-900 p-4 rounded-2xl border border-border-color dark:border-slate-800 shadow-sm hover:shadow-card-hover hover:border-primary/30 transition-all duration-300">
                        <div className="size-14 rounded-2xl bg-primary/20 group-hover:bg-primary/25 dark:bg-blue-900/30 text-primary flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                            <FaSyringe className="text-3xl" />
                        </div>
                        <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">Chronic Illness Care</h3>
                        <p className="text-text-secondary dark:text-slate-400 leading-relaxed">
                            Ongoing support for managing conditions like diabetes, hypertension, and respiratory issues with regular checkups.
                        </p>
                        <hr className="my-6 border-slate-200 dark:border-slate-800" />
                        <Link
                            to={'/services'}
                            className="text-primary font-bold inline-flex items-center gap-2 group-hover:gap-3 transition-all"
                        >
                            Learn more <span className="text-sm">→</span>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;